module.exports = __webpack_public_path__ + "img/spare.cbf03bf7.png";